import React from "react";
import { useTranslation } from "react-i18next";
import TrendIndicator from "../../../../parts/TrendIndicator";

function CalendarTrendLegend({ activeUser }) {
  const { t } = useTranslation("dashboard");
  const intensityMeasure = (
    activeUser?.intensityMeasure || "RPE"
  ).toUpperCase();

  return (
    <div className="calendar-trend-legend">
      <span className="calendar-trend-legend-title">
        {t("calendar.relLegend.title")}
      </span>
      <span className="calendar-trend-legend-item">
        <TrendIndicator curr={1} prev={0} metric="reps" />
        {t("calendar.relLegend.increase")}
      </span>
      <span className="calendar-trend-legend-item">
        <TrendIndicator curr={0} prev={1} metric="reps" />
        {t("calendar.relLegend.decrease")}
      </span>
      <span className="calendar-trend-legend-item">
        <TrendIndicator curr={0} prev={0} metric="reps" />
        {t("calendar.relLegend.noChange")}
      </span>
      <span className="calendar-trend-legend-sep" />
      <span className="calendar-trend-legend-keys">
        {t("calendar.relLegend.keysHint", { intensity: intensityMeasure })}
      </span>
      <span className="calendar-trend-legend-sep" />
      <span className="calendar-trend-legend-item">
        <TrendIndicator curr={1} prev={0} metric="rpe" />
        {t("calendar.relLegend.rpeHarder", { intensity: intensityMeasure })}
      </span>
      <span className="calendar-trend-legend-item">
        <TrendIndicator curr={0} prev={1} metric="rpe" />
        {t("calendar.relLegend.rpeEasier", { intensity: intensityMeasure })}
      </span>
    </div>
  );
}

export default CalendarTrendLegend;
